module.exports = __webpack_public_path__ + "static/UNB-cfde03e7ff4acf73bec377bcf8ac2976.ttf";